<template>
    <v-app>
        <v-container fluid>
            <v-row>
                <v-col class="mx-auto" offset-sm="1" sm="10" offset-md="2" md="8" offset-lg="4" lg="4">
                    <v-card class="mt-5 mx-auto" v-if="mode === 'login'">
                        <v-form @submit.prevent="loginUser">
                            <validation-observer
                                ref="observer"
                                v-slot="{ invalid }"
                            >
                                <v-card-title class="pb-0">
                                    <h1 class="display-1">Ingreso</h1>
                                </v-card-title>
                                <v-card-text>
                                    <v-row>
                                        <v-col>
                                            <validation-provider
                                                v-slot="{ errors }"
                                                name="RUT"
                                                :rules="{
                                              required: true,
                                              regex: '^\\d*-([0-9]|[kK])$'
                                            }"
                                            >
                                                <v-text-field
                                                    v-model="login.rut"
                                                    label="RUT"
                                                    prepend-icon="mdi-account-circle"
                                                    placeholder="12345678-k"
                                                    :error-messages="errors"
                                                />
                                            </validation-provider>
                                        </v-col>
                                        <v-col>
                                            <validation-provider
                                                v-slot="{ errors }"
                                                name="Password"
                                                :rules="{required: true}"
                                            >
                                                <v-text-field
                                                    v-model="login.email"
                                                    :type="showPassword ? 'text' : 'password'"
                                                    label="Password"
                                                    prepend-icon="mdi-lock"
                                                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                                    @click:append="showPassword = !showPassword"
                                                    :error-messages="errors"
                                                />
                                            </validation-provider>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                                <v-divider></v-divider>
                                <v-card-actions>
                                    <v-btn @click="switchAuthMode" color="info">Ir al registro</v-btn>
                                    <v-spacer></v-spacer>
                                    <v-btn :disabled="invalid" type="submit" color="success">Ingresar</v-btn>
                                </v-card-actions>
                            </validation-observer>
                        </v-form>
                    </v-card>
                    <v-card class="mt-5 mx-auto" v-else>
                        <v-form @submit.prevent="createUser">
                            <validation-observer
                                ref="observer"
                                v-slot="{ invalid }"
                            >
                                <v-card-title class="pb-0">
                                    <h1 class="display-1">Registro</h1>
                                </v-card-title>
                                <v-card-text>
                                    <v-row class="mb-n6">
                                        <v-col>
                                            <validation-provider
                                                v-slot="{ errors }"
                                                name="RUT"
                                                :rules="{
                                              required: true,
                                              regex: '^\\d*-([0-9]|[kK])$'
                                            }"
                                            >
                                                <v-text-field
                                                    v-model="register.rut"
                                                    label="RUT"
                                                    prepend-icon="mdi-account-circle"
                                                    placeholder="12345678-k"
                                                    :error-messages="errors"
                                                />
                                            </validation-provider>
                                        </v-col>
                                        <v-col>
                                            <validation-provider
                                                v-slot="{ errors }"
                                                name="Correo electrónico"
                                                rules="required|email"
                                            >
                                                <v-text-field
                                                    v-model="register.email"
                                                    label="Correo electrónico"
                                                    type="email"
                                                    prepend-icon="mdi-email"
                                                    placeholder="pepito@gmail.com"
                                                    :error-messages="errors"
                                                />
                                            </validation-provider>
                                        </v-col>
                                    </v-row>
                                    <v-row class="my-n6">
                                        <v-col>
                                            <validation-provider
                                                v-slot="{ errors }"
                                                name="Nombres"
                                                rules="required"
                                            >
                                                <v-text-field
                                                    v-model="register.firstName"
                                                    label="Nombres"
                                                    prepend-icon="mdi-text-account"
                                                    placeholder="José Pedro"
                                                    :error-messages="errors"
                                                />
                                            </validation-provider>
                                        </v-col>
                                    </v-row>
                                    <v-row class="mt-n6">
                                        <v-col>
                                            <validation-provider
                                                v-slot="{ errors }"
                                                name="Apellido Paterno"
                                                rules="required"
                                            >
                                                <v-text-field
                                                    v-model="register.fatherLastName"
                                                    label="Apellido Paterno"
                                                    prepend-icon="mdi-text-account"
                                                    placeholder="López"
                                                    :error-messages="errors"
                                                />
                                            </validation-provider>
                                        </v-col>
                                        <v-col>
                                            <validation-provider
                                                v-slot="{ errors }"
                                                name="Apellido Paterno"
                                                rules="required"
                                            >
                                                <v-text-field
                                                    v-model="register.motherLastName"
                                                    label="Apellido Materno"
                                                    prepend-icon="mdi-text-account"
                                                    placeholder="Pérez"
                                                    :error-messages="errors"
                                                />
                                            </validation-provider>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col>
                                            <v-menu
                                                v-model="register.menu"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                transition="scale-transition"
                                                offset-y
                                                min-width="auto"
                                            >
                                                <template v-slot:activator="{ on, attrs }">
                                                    <validation-provider
                                                        v-slot="{ errors }"
                                                        name="Fecha de nacimiento"
                                                        rules="required"
                                                    >
                                                        <v-text-field
                                                            v-model="computedDateFormatted"
                                                            label="Seleccione su fecha de nacimiento"
                                                            prepend-icon="mdi-calendar"
                                                            readonly
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            :error-messages="errors"
                                                        ></v-text-field>
                                                    </validation-provider>
                                                </template>
                                                <v-date-picker
                                                    v-model="register.birthDate"
                                                    @input="register.menu = false"
                                                    first-day-of-week="1"
                                                    locale="es-CL"
                                                >
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                    </v-row>
                                    <v-divider></v-divider>
                                    <v-row class="mb-n6">
                                        <v-col>
                                            <validation-provider
                                                v-slot="{ errors }"
                                                name="Calle"
                                                rules="required"
                                            >
                                                <v-text-field
                                                    v-model="register.address.street"
                                                    label="Calle"
                                                    prepend-icon="mdi-road-variant"
                                                    placeholder="Alameda"
                                                    :error-messages="errors"
                                                />
                                            </validation-provider>
                                        </v-col>
                                        <v-col>
                                            <validation-provider
                                                v-slot="{ errors }"
                                                name="Número"
                                                rules="required"
                                            >
                                                <v-text-field
                                                    v-model="register.address.number"
                                                    label="Número"
                                                    prepend-icon="mdi-pound"
                                                    placeholder="720"
                                                    :error-messages="errors"
                                                />
                                            </validation-provider>
                                        </v-col>
                                    </v-row>
                                    <v-row class="mt-n6">
                                        <v-col>
                                            <validation-provider
                                                v-slot="{ errors }"
                                                name="Comuna"
                                                rules="required"
                                            >
                                                <v-text-field
                                                    v-model="register.address.commune"
                                                    label="Comuna"
                                                    prepend-icon="mdi-map-marker-radius"
                                                    placeholder="Cerrillos"
                                                    :error-messages="errors"
                                                />
                                            </validation-provider>
                                        </v-col>
                                        <v-col>
                                            <validation-provider
                                                v-slot="{ errors }"
                                                name="Ciudad"
                                                rules="required"
                                            >
                                                <v-text-field
                                                    v-model="register.address.city"
                                                    label="Ciudad"
                                                    prepend-icon="mdi-map-marker-radius"
                                                    placeholder="Santiago"
                                                    :error-messages="errors"
                                                />
                                            </validation-provider>
                                        </v-col>
                                    </v-row>
                                    <v-divider></v-divider>
                                    <v-row>
                                        <v-col>
                                            <validation-provider
                                                v-slot="{ errors }"
                                                name="Teléfono 1"
                                                rules="required"
                                            >
                                                <v-text-field
                                                    v-model="register.phoneNumbers[0]"
                                                    label="Teléfono 1"
                                                    prepend-icon="mdi-cellphone"
                                                    placeholder="9 88 34 75 23"
                                                    :error-messages="errors"
                                                />
                                            </validation-provider>
                                        </v-col>
                                        <v-col>
                                            <v-text-field
                                                v-model="register.phoneNumbers[1]"
                                                label="Teléfono 2"
                                                prepend-icon="mdi-phone-classic"
                                                placeholder="2 28 56 23 55"
                                            />
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                                <v-divider></v-divider>
                                <v-card-actions>
                                    <v-btn @click="switchAuthMode" color="info">Ir al ingreso</v-btn>
                                    <v-spacer></v-spacer>
                                    <v-btn :disabled="invalid" type="submit" color="success">Registrarse</v-btn>
                                </v-card-actions>
                            </validation-observer>
                        </v-form>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
import {required, email, regex} from 'vee-validate/dist/rules';
import {extend, ValidationObserver, ValidationProvider, setInteractionMode} from 'vee-validate';

setInteractionMode('eager');


extend('required', {
    ...required,
    message: 'El campo {_field_} no puede ser vacío',
});

extend('regex', {
    ...regex,
    message: '{_field_} {_value_} no está en el formato correcto {regex}',
});

extend('email', {
    ...email,
    message: 'Debe ingresar un correo válido',
})

export default {
    components: {
        ValidationProvider,
        ValidationObserver,
    },
    data() {
        return {
            showPassword: false,
            mode: 'login',
            login: {
                rut: "",
                email: ""
            },
            register: {
                rut: "",
                email: "",
                firstName: '',
                fatherLastName: '',
                motherLastName: '',
                address: {
                    street: '',
                    number: '',
                    commune: '',
                    city: ''
                },
                phoneNumbers: [],
                birthDate: '',
                birthDateComputed: '',
                menu: '',
            }
        };
    },
    methods: {
        submit() {
            this.$refs.observer.validate()
        },
        async loginUser() {
            await this.$store.dispatch('login', this.login)
            this.$router.replace('/agenda')
        },
        async createUser() {
            await this.$store.dispatch('register', this.register);
            this.$router.replace('/home')
        },
        switchAuthMode() {
            if (this.mode === 'login') {
                this.mode = 'signup';
            } else {
                this.mode = 'login';
            }
        },
        formatDate(date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
        parseDate(date) {
            if (!date) return null

            const [month, day, year] = date.split('/')
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        },
    },
    watch: {
        birthDate() {
            this.register.dateFormatted = this.formatDate(this.register.birthDate)
        },
    },
    computed: {
        computedDateFormatted() {
            return this.formatDate(this.register.birthDate)
        },
    },
};
</script>
